/* eslint-disable no-underscore-dangle */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import classNames from "classnames/bind";
import { connect } from "react-redux";

import * as searchAddressActions from "../../../account/components/AccountTab/components/Address/store/actions";
import * as profileActions from "../../../account/components/AccountTab/components/MyProfile/store/actions";
import { optionsTitle } from "../../../../config/types";
import { getCredentials, getErrors } from "../../store/selectors";
import * as registerActions from "../../store/actions";
import {
  Button,
  Input,
  Select,
  SearchInput,
  // SearchBar,
} from "../../../../components";
import {
  getAddresses,
  getPostcode,
} from "../../../account/components/AccountTab/components/Address/store/selectors";
import { CRAFTY_CLICKS_API_KEY } from "../../../../config/apiKeys";
import styles from "./styles";

class Form extends Component {
  state = {
    terms: false,
  };

  static propTypes = {
    classes: PropTypes.object,
    credentials: PropTypes.object,
    changeField: PropTypes.func,
    changeFieldAddress: PropTypes.func,
    registerFormReset: PropTypes.func,
    changeErrors: PropTypes.func,
    errors: PropTypes.object,
    toCheckout: PropTypes.bool,

    changeFieldSearch: PropTypes.func,
    searchAddress: PropTypes.func,
    postcode: PropTypes.string,
    addresses: PropTypes.array,
    requestSelectedAddress: PropTypes.func,
    verifyPhoneNumber: PropTypes.func,
  };

  static defaultProps = {
    classes: {},
    credentials: {
      address: {},
    },
    toCheckout: false,
    changeField: () => {},
    changeFieldAddress: () => {},
    registerFormReset: () => {},
    changeErrors: () => {},
    errors: {},
    changeFieldSearch: () => {},
    searchAddress: () => {},
    requestSelectedAddress: () => {},
    verifyPhoneNumber: () => {},
    postcode: null,
    addresses: [],
  };

  handleChangeTerms = () => {
    const { terms } = this.state;
    const { errors, changeErrors } = this.props;
    this.setState({ terms: !terms });
    if (errors.common && !terms) {
      changeErrors("common", null);
    }
  };

  onChangeInput = (value, name) => {
    this.props.changeField(value, name);
  };

  onChangeInputAddress = (value, name) => {
    this.props.changeFieldAddress(value, name);
  };

  checkPassword = () => {
    const { credentials, changeErrors } = this.props;

    if (credentials.Password !== credentials.ConfirmPassword) {
      changeErrors("common", "Passwords do not match");
      return false;
    }

    if (credentials.Password.length < 8) {
      changeErrors(
        "common",
        "Please enter a password that is 8 or more characters"
      );
      return false;
    }

    if (credentials.Password.length > 50) {
      changeErrors("common", "Password must not exceed 50 characters");
      return false;
    }

    if (!/[A-Z]/.test(credentials.Password)) {
      changeErrors(
        "common",
        "Please enter a password that contain an upper case character"
      );
      return false;
    }

    if (!/[a-z]/.test(credentials.Password)) {
      changeErrors(
        "common",
        "Please enter a password that contains lower case characters"
      );
      return false;
    }

    if (!/[!£$%'()*,\-.:;<=>?@[\]{}^_`|~]/.test(credentials.Password)) {
      changeErrors(
        "common",
        "Please enter a password that contains special characters"
      );
      return false;
    }

    return true;
  };

  onRegister = (e) => {
    e.preventDefault();
    const { terms } = this.state;
    const { credentials, changeErrors, toCheckout, verifyPhoneNumber } =
      this.props;
    if (this.checkPassword()) {
      if (terms) {
        const cartId = localStorage.getItem("CartID");
        const data = {
          ...credentials,
        };
        if (cartId) data.cartId = cartId;
        verifyPhoneNumber(
          {
            key: CRAFTY_CLICKS_API_KEY,
            country: "gbr",
            phone_number: this.props.credentials.Mobile,
            get_network: true,
          },
          { data: credentials, toCheckout }
        );
      } else {
        changeErrors("common", "! You should accept terms and conditions");
      }
    }
    return false;
  };

  componentWillUnmount() {
    this.props.registerFormReset();
  }

  render() {
    const { classes, errors } = this.props;

    const topText1 = "Thanks for registering with SellItBack.com!";

    const topText2 = `Please fill in the details below so we know where your
    stuff is coming from. We do not share your personal information with
    anyone, so rest assured your details are safe with us.
    We only ask for those details which are absolutely necessary.`;

    const registerDisclaimer = `(We need these details in case we need to confirm your
      identity when we issue payment for your items)`;

    const termsPolicy =
      "By registering you are confirming that you agree to our ";
    const termsConditions = "Terms and conditions ";
    const privacyPolicy = " Privacy Policy";
    const mobileTooltip = `(We send you SMS order updates when your item has been received,
       processed and payments made to your account)`;
    const bookshopNameTooltip = `Running a bookshop trade-in scheme? Tell us its name and
       we'll set your account up for it.`;
    const checkboxText = `Yes I want to receive special discounts and updates with our newsletter.
    You can cancel anytime.`;

    return (
      <div className={classes.mainContainer}>
        <form
          action="#"
          onSubmit={this.onRegister}
          className={"needs-validation"}
          noValidate
        >
          <div className={classNames("form-group", classes.form)}>
            <span
              className={classNames(classes.topTextStyle, classes.topText1)}
            >
              {topText1}
            </span>
            <span
              className={classNames(classes.topTextStyle, classes.topText2)}
            >
              {topText2}
            </span>
            <div
              className={classNames(
                classes.rowContainer,
                classes.rowContainerFlexEnd
              )}
            >
              <Select
                fixedWidth
                options={optionsTitle}
                onChange={this.onChangeInput}
                name={"Title"}
                value={this.props.credentials.Title}
                label={"Title"}
              />
              <Input
                label={"First Name:"}
                fixedWidth
                required
                name={"ForeName"}
                value={this.props.credentials.ForeName}
                onChange={this.onChangeInput}
              />
            </div>
            <div className={classes.rowContainer}>
              <Input
                label={"Last Name:"}
                fixedWidth
                required
                name={"SurName"}
                value={this.props.credentials.SurName}
                onChange={this.onChangeInput}
              />
              <Input
                label={"Email:"}
                inputType={"email"}
                fixedWidth
                required
                name={"EmailID"}
                value={this.props.credentials.EmailID}
                onChange={this.onChangeInput}
              />
            </div>
            <div className={classes.rowContainerWithBottomHelper}>
              <div className={classes.inputWithBottomHelper}>
                <Input
                  label={"Password"}
                  inputType={"password"}
                  minLength={6}
                  fixedWidth
                  required
                  name={"Password"}
                  value={this.props.credentials.Password}
                  onChange={this.onChangeInput}
                />
                <span className={classes.passwordHelper}>
                  (Your password must be at least 8 characters long and must
                  include at least one number and special character.)
                </span>
              </div>
              <Input
                label={"Confirm password:"}
                fixedWidth
                inputType={"password"}
                required
                name={"ConfirmPassword"}
                value={this.props.credentials.ConfirmPassword}
                onChange={this.onChangeInput}
              />
            </div>
            <div className={classes.rowContainer}>
              {/* <SearchBar
                style={classes.searchInputStyle}
                changeField={this.props.changeFieldSearch}
                onChange={this.onChangeInputAddress}
                postcode={this.props.postcode}
              /> */}
              <SearchInput
                style={classes.searchInputStyle}
                changeField={this.props.changeFieldSearch}
                searchAddress={this.props.searchAddress}
                postcode={this.props.postcode}
                addresses={this.props.addresses}
                requestSelectedAddress={this.props.requestSelectedAddress}
              />
              <Input
                label={"Postcode:"}
                fixedWidth
                name={"Postcode"}
                value={this.props.credentials.address.Postcode}
                onChange={this.onChangeInputAddress}
              />
            </div>
            <div className={classNames(classes.rowContainer)}>
              <Input
                fixedWidth
                label={"Address Line 1:"}
                name={"AddressLine1"}
                value={this.props.credentials.address.AddressLine1}
                onChange={this.onChangeInputAddress}
              />
              <Input
                fixedWidth
                label={"Address Line 2:"}
                name={"AddressLine2"}
                value={this.props.credentials.address.AddressLine2}
                onChange={this.onChangeInputAddress}
              />
            </div>
            <div className={classes.rowContainer}>
              <Input
                label={"Town:"}
                fixedWidth
                required
                name={"Town"}
                value={this.props.credentials.address.Town}
                onChange={this.onChangeInputAddress}
              />
              <Input
                label={"County:"}
                fixedWidth
                required
                name={"County"}
                value={this.props.credentials.address.County}
                onChange={this.onChangeInputAddress}
              />
            </div>
            <div className={classes.rowContainerWithBottomHelper}>
              <div className={classes.inputWithBottomHelper}>
                <Input
                  label={"Mobile number"}
                  required
                  fixedWidth
                  name={"Mobile"}
                  value={this.props.credentials.Mobile}
                  onChange={this.onChangeInput}
                />
                <span className={classes.passwordHelper}>{mobileTooltip}</span>
              </div>
            </div>
            <div className={classes.rowContainerWithBottomHelper}>
              <div className={classes.inputWithBottomHelper}>
                <Input
                  label={"Bookshop name (optional):"}
                  fixedWidth
                  name={"BookshopName"}
                  value={this.props.credentials.BookshopName}
                  onChange={this.onChangeInput}
                />
                <span className={classes.passwordHelper}>
                  {bookshopNameTooltip}
                </span>
              </div>
            </div>
            <span className={classes.registerDisclaimer}>
              {registerDisclaimer}
            </span>
            <div
              className={classNames(
                classes.registerDisclaimer,
                classes.paddingLeft
              )}
            >
              <input
                type={"checkbox"}
                className={`form-check-input ${classes.checkbox}`}
                id={"check-1"}
                value={this.state.terms}
                onChange={this.handleChangeTerms}
              />
              <span className={classes.termsTextContainer}>
                <span>{termsPolicy}</span>
                <Link to={"/terms"} className={classes.blueColor}>
                  {termsConditions}
                </Link>
                <span>and</span>
                <Link to={"/privacy"} className={classes.blueColor}>
                  {privacyPolicy}
                </Link>
              </span>
            </div>
            <div
              className={classNames(
                classes.registerDisclaimer,
                classes.paddingLeft
              )}
            >
              <input
                type={"checkbox"}
                className={`form-check-input ${classes.checkbox}`}
                id={"check-2"}
                value={this.props.credentials.NewsLetter}
                onChange={() =>
                  this.props.changeField(
                    !this.props.credentials.NewsLetter,
                    "NewsLetter"
                  )
                }
              />
              <span className={classes.termsTextContainer}>{checkboxText}</span>
            </div>
          </div>
          {errors.common && (
            <span className={classes.error}>{errors.common}</span>
          )}
          <Button
            onPress={this.onRegister}
            text={"register"}
            style={classes.buttonStyleSubmit}
          />
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    credentials: getCredentials(state),
    errors: getErrors(state),
    postcode: getPostcode(state),
    addresses: getAddresses(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    registerFormReset: () => dispatch(registerActions.registerFormReset()),
    changeField: (value, name) =>
      dispatch(registerActions.changeField(value, name)),
    changeFieldAddress: (value, name) =>
      dispatch(registerActions.changeFieldAddress(value, name)),
    changeFieldBank: (value, name) =>
      dispatch(registerActions.changeFieldBank(value, name)),
    changeErrors: (field, error) =>
      dispatch(registerActions.changeErrors(field, error)),

    changeFieldSearch: (value, name) =>
      dispatch(searchAddressActions.changeField(value, name)),
    searchAddress: (data) =>
      dispatch(searchAddressActions.requestAddressSearch(data)),
    requestSelectedAddress: (data) =>
      dispatch(registerActions.requestSelectedAddress(data)),
    verifyPhoneNumber: (data, dataForNextRequest) =>
      dispatch(profileActions.verifyPhoneNumber(data, dataForNextRequest)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(Form));
